export default function AboutSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      color: 'bg-emerald-100 text-emerald-700',
      title: 'Modération sécurisée',
      desc: 'Chaque vendeur et organisateur est validé par notre équipe avant de pouvoir publier. Zéro arnaque, 100% fiable.',
    },
    {
      icon: 'ri-dashboard-2-line',
      color: 'bg-gold-100 text-gold-dark',
      title: 'Tableau de bord complet',
      desc: 'Suivez vos ventes, commandes, tickets et revenus en temps réel depuis une interface intuitive et moderne.',
    },
    {
      icon: 'ri-notification-4-line',
      color: 'bg-navy/10 text-navy',
      title: 'Notifications instantanées',
      desc: 'Restez informé de chaque action : approbation, commande, réservation, commentaire, en temps réel.',
    },
    {
      icon: 'ri-pie-chart-2-line',
      color: 'bg-teal-100 text-teal-700',
      title: 'Analyses & Statistiques',
      desc: 'Graphiques détaillés, rapports financiers, tendances de ventes. Prenez des décisions éclairées.',
    },
    {
      icon: 'ri-smartphone-line',
      color: 'bg-amber-100 text-amber-700',
      title: '100% Responsive',
      desc: "Gérez votre activité depuis n'importe quel appareil : ordinateur, tablette ou smartphone.",
    },
    {
      icon: 'ri-customer-service-2-line',
      color: 'bg-rose-100 text-rose-600',
      title: 'Support dédié',
      desc: "Une équipe disponible pour vous accompagner à chaque étape de votre activité sur la plateforme.",
    },
  ];

  const steps = [
    {
      step: '01',
      icon: 'ri-user-add-line',
      title: 'Créez votre compte',
      desc: "Remplissez le formulaire d'inscription en tant que vendeur ou organisateur. Simple et rapide.",
      color: 'bg-gold-100 text-gold-dark border-gold/30',
    },
    {
      step: '02',
      icon: 'ri-shield-user-line',
      title: "Validation par l'admin",
      desc: "Notre équipe examine votre profil et valide votre inscription sous 24-48h. Vous recevrez une notification.",
      color: 'bg-navy/10 text-navy border-navy/20',
    },
    {
      step: '03',
      icon: 'ri-rocket-2-line',
      title: 'Lancez votre activité',
      desc: "Accédez à votre tableau de bord, publiez vos produits ou événements, et commencez à gagner !",
      color: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    },
  ];

  return (
    <section id="about" className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold-50 px-4 py-2">
            <i className="ri-star-line text-sm text-gold"></i>
            <span className="text-sm font-semibold text-gold-dark">Pourquoi choisir Foi Senegal ?</span>
          </div>
          <h2 className="mb-4 text-4xl font-bold text-navy md:text-5xl">
            Une plateforme conçue
            <br />
            pour les eglises du Senegal
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-gray-500">
            Foi Senegal centralise l'ensemble des eglises du Senegal au sein d'une plateforme numerique unique et modernise l'acces aux services religieux grace aux technologies mobiles.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group rounded-2xl border border-gray-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-gold/30"
            >
              <div className={`mb-4 flex h-12 w-12 items-center justify-center rounded-xl ${feature.color}`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="mb-2 text-base font-bold text-navy">{feature.title}</h3>
              <p className="text-sm leading-relaxed text-gray-500">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-24">
          <div className="mb-12 text-center">
            <h3 className="mb-3 text-3xl font-bold text-navy">Comment ça fonctionne ?</h3>
            <p className="text-gray-500">En 3 etapes simples, rejoignez l'ecosysteme Foi Senegal</p>
          </div>

          <div className="relative grid grid-cols-1 gap-8 md:grid-cols-3">
            <div className="absolute left-[calc(33.33%+1rem)] right-[calc(33.33%+1rem)] top-8 hidden h-0.5 bg-gold/30 md:block"></div>

            {steps.map((step) => (
              <div key={step.step} className="flex flex-col items-center text-center">
                <div className={`relative mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border-2 ${step.color}`}>
                  <i className={`${step.icon} text-2xl`}></i>
                  <span className="absolute -right-3 -top-3 flex h-6 w-6 items-center justify-center rounded-full bg-navy text-xs font-bold text-white">
                    {step.step}
                  </span>
                </div>
                <h4 className="mb-2 text-base font-bold text-navy">{step.title}</h4>
                <p className="text-sm leading-relaxed text-gray-500">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
